import { ApplicationRelationshipLicense } from 'commons/types/DTO/bank/applications'

export const isExistsUnAssigned = ({ licenses }: { licenses: ApplicationRelationshipLicense[] }) =>
  !!licenses.find(({ isAssigned }) => !isAssigned)
